import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinanciero';
import mixAvanceFisico from '@/helpers/calculos/mixAvanceFisico';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainEstimacionesReporteControlEstimaciones',
  mixins: [mixAvanceProgramado, mixAvanceFinanciero, mixAvanceFisico,
    mixGenerarPdf, mixFormatoEstructura],
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfControl() {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);

      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const supervisor = this.getSupervisor || '';
      const firmasFuncionarios = encabezadoReferencia.firmas || [];
      const datosCalculados = {
        contratoTotalAnticipo: this.contratoTotalAnticipo,
        contratoAvanceFisico: this.getAvanceFisico,
        contratoAvanceFinanciero: this.getPorcentajeAvanceFinanciero,
        amortizacionAnticipoAcumuladoAnteriror: this.amortizacionAnticipoAcumuladoAnteriror,
        amortizacionAnticipoAcumuladoTotal: this.amortizacionAnticipoAcumuladoTotal,
        amortizacionAnticipoSaldo: this.amortizacionAnticipoSaldo,
        estimadoAcumuladoAnteriror: this.estimadoAcumuladoAnteriror,
        acumuladoTotal: this.acumuladoTotal,
        saldoContrato: this.saldoContrato,
        contratoTotalAnticipoFinanciado: this.contratoTotalAnticipoFinanciado,
        importeAmortizacionAnticipoFinanciado: this.importeAmortizacionAnticipoFinanciado,
        sumaAmortizacionAnticipoFinanciado: this.sumaAmortizacionAnticipoFinanciado,
        saldoAmortizacionAnticipoFinanciado: this.saldoAmortizacionAnticipoFinanciado,
        importeContrato: this.importeDelContrato,
        programaInversion: this.getTipoInversion,
        supervisionExterna: this.getContratoSupervisionExterna?.contratoRelacionado
          ?.contratista?.nombreRazonSocial || '',
      };
      const datos = this.formatoObjeto(datosCalculados);
      const conveniosConFormato = this.formatoObjeto(this.getContratoConvenios);

      let nombreTemplate = 'templateControlEstimacion';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateControlEstimacionOPF'; }

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          convenios: conveniosConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: firmasFuncionarios,
          datos,
          footer: '',
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_Control_Estimacion_${this.estimacion.numero}`);
      this.generandoPdfControlEstimaciones = false;
      this.$emit('terminando');
    },
  },
  computed: {
    importeDelContrato() {
      return this.estimacion.importeContratoSinFinanciamiento;
    },
    numeroEstimacion() {
      return Number(this.estimacion.numero);
    },
    contratoTotalAnticipo() {
      return this.estimacion.importeAnticipo;
    },
    contratoTotalAnticipoFinanciado() {
      return this.estimacion.importeAnticipoFinanciamiento;
    },
    estimacionesAnteriores() {
      return this.estimaciones
        .filter(({ numero }) => Number(numero) < this.numeroEstimacion);
    },
    getPorcentajeAvanceFinanciero() {
      const estimacionesAnterioes = this.estimaciones
        .filter(({ numero }) => Number(numero) <= this.numeroEstimacion);

      let importeEstimado = 0;
      estimacionesAnterioes.forEach((est) => {
        importeEstimado += parseFloat(est.importeEstimado) || 0;
        importeEstimado = this.$numberRound(importeEstimado);
      });

      return (this.$numberRoundDigits((importeEstimado / this.importeDelContrato) * 100, 2));
    },
    amortizacionAnticipoAcumuladoAnteriror() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeAmortizacionAnticipo');
    },
    importeAmortizacionAnticipoFinanciado() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeCostoFinancieroAmortizacionAnticipo');
    },
    sumaAmortizacionAnticipoFinanciado() {
      return (this.importeAmortizacionAnticipoFinanciado
      + this.estimacion.importeCostoFinancieroAmortizacionAnticipo);
    },
    amortizacionAnticipoAcumuladoTotal() {
      return (
        this.amortizacionAnticipoAcumuladoAnteriror
        + this.estimacion.importeAmortizacionAnticipo);
    },
    amortizacionAnticipoSaldo() {
      return (this.contratoTotalAnticipo - this.amortizacionAnticipoAcumuladoTotal);
    },
    saldoAmortizacionAnticipoFinanciado() {
      return (this.contratoTotalAnticipoFinanciado - this.sumaAmortizacionAnticipoFinanciado);
    },
    estimadoAcumuladoAnteriror() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeEstimado');
    },
    acumuladoTotal() {
      return (this.estimacion.importeEstimado + this.estimadoAcumuladoAnteriror);
    },
    saldoContrato() {
      return (this.importeDelContrato - this.acumuladoTotal);
    },
    ordenarListadoFirmas() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden);
    },
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoConvenios() {
      if (!this.contrato.convenios) return [];
      const conveniosPlazo = this.contrato.convenios
        .filter((c) => c.tipo === 'PLAZO').sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
      const conveniosResto = this.contrato.convenios
        .filter((c) => c.tipo !== 'PLAZO');
      return ([conveniosPlazo[0], ...conveniosResto]
        .sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`)));
    },
    getContratoSupervisionExterna() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
    getPrograma() {
      if (this.contrato.obras.length <= 0) return 'MUNICIPAL';
      if (!this.contrato.obras[0].obra.programa) return 'MUNICIPAL';
      return this.contrato.obras[0].obra.programa.nombre;
    },
    getTipoInversion() {
      if (this.contrato.obras.length <= 0) return 'MUNICIPAL';
      if (!this.contrato.obras[0].obra.programa) return 'MUNICIPAL';
      return this.contrato.obras[0].obra.programa.nombre;
    },
    getAvanceFisico() {
      if (this.estimacion.esEstimacionFiniquito) return 100;
      return this.getPorcentajeAvanceFinanciero;
    },
  },
};
